module.exports = __webpack_public_path__ + "img/ecosen.6737b785.png";